export const getPermissions = (auth) =>
    auth?.user?.privilege?.permissions ?? (Array.isArray(auth?.user?.privilege) ? auth.user.privilege : []) ?? [];

export const hasPermission = (permissions, resource, action = "read") => {
    if (!Array.isArray(permissions)) return false;
    const p = permissions.find((x) => x.resource === resource);
    return p ? Array.isArray(p.action) && p.action.includes(action) : false;
};
